module.exports = __webpack_public_path__ + "img/beyla.3e11251b.png";